import React, { useEffect, useState } from 'react';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const BARS = [
  { key: 'doseReduced', label: 'Dose reduced', color: '#F97316' },
  { key: 'therapyHold', label: 'Therapy holds', color: '#EF4444' },
  { key: 'doseIncreased', label: 'Dose increased', color: '#6366F1' },
];

const DoseModifications = ({ requestData }) => {
  const [doseModificationsData, setDoseModificationsData] = useState(null);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getDoseModifications(requestData);

        setDoseModificationsData(data.data);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const isEmpty = BARS.every(({ key }) => !doseModificationsData?.[key]);

  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    if (!loading && doseModificationsData && !isEmpty) {
      const id = requestAnimationFrame(() => setAnimated(true));
      return () => cancelAnimationFrame(id);
    }
    setAnimated(false);
  }, [loading, doseModificationsData]);

  return (
    <div className={classes.chart_kpi_wrapper} style={{ padding: 16, minHeight: 176 }}>
      <p style={{
        margin: '0 0 20px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        Dose modifications
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : isEmpty
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <>
              {BARS.map(({ key, label, color }, idx) => {
                const pct = doseModificationsData[key] ?? 0;
                return (
                  <div key={key} style={{ marginBottom: 6 }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: 6,
                      fontSize: 13,
                      color: '#6B7280',
                    }}
                    >
                      <span>{label}</span>
                      <span style={{ fontWeight: 700, color: '#111827' }}>{`${pct}%`}</span>
                    </div>

                    <div style={{
                      height: 8,
                      borderRadius: 4,
                      background: '#E5E7EB',
                      overflow: 'hidden',
                    }}
                    >
                      <div style={{
                        height: '100%',
                        borderRadius: 4,
                        background: color,
                        width: animated ? `${Math.max(pct, 0)}%` : '0%',
                        transition: `width 0.8s cubic-bezier(0.4, 0, 0.2, 1) ${idx * 0.15}s`,
                      }}
                      />
                    </div>
                  </div>
                );
              })}
            </>
          )}
    </div>
  );
};

export default DoseModifications;
